import { CART_CLEAR } from "./CartActionTypes";

export const clearCartAction =
  () =>
  (dispatch: any) => {
    dispatch({ type: CART_CLEAR });
  };
